import { compareByNumericProp } from '../../utils/comparators';

/**
 * @return changelogs for given buildings, sorted by date
 * if date is non-null we only include changelog entries more recent than it
 */
export const getChangelogsForBuildings = (state, buildings, date) => {
  const {
    entities: {
      buildingChangelogs: { logs },
    },
  } = state;
  const allEntries = [].concat(...buildings.map((bid) => logs[bid])).filter((e) => e != null);
  allEntries.sort(compareByNumericProp('timestamp', 'desc'));
  if (date != null) {
    return allEntries.filter(({ timestamp }) => timestamp >= date);
  }
  return allEntries;
};

export const allLoaded = (
  {
    entities: {
      buildingChangelogs: { loaded },
    },
  },
  buildings
) => buildings.every((bid) => loaded.has(bid));
